<template>
  <div>
    <van-field readonly clickable right-icon="arrow-down" placeholder="请选择" :value="value" @click="popup = true" />
    <van-popup ref="popup" v-model="popup" round position="bottom" :close-on-click-overlay="false">
      <van-datetime-picker
        :value="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        type="datetime"
        title="选择年月日"
        @cancel="popup = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import pad from 'lodash/padStart'
import dateTimeMixin from './date-time-mixin'

export default {
  name: 'DateTimeMinute',
  mixins: [dateTimeMixin],
  methods: {
    onConfirm(value) {
      let year = value.getFullYear()
      let m = pad((value.getMonth() + 1).toString(), 2, '0')
      let d = pad(value.getDate().toString(), 2, '0')
      let h = pad(value.getHours().toString(), 2, '0')
      let min = pad(value.getMinutes().toString(), 2, '0')
      this.popup = false
      this.$emit('input', `${year}-${m}-${d} ${h}:${min}`)
    }
  }
}
</script>

<style scoped></style>
